module.exports = require('./helpers/bundle-url').getBundleURL('6gjun') + "../images/route.287d9e3a..svg" + "?" + Date.now();